"use client";
import React from "react";
import { useState, useEffect } from 'react';
import { Button } from "ii-ui-kit";

import "./CookieBanner.scss";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  // Проверяем наличие куки-флага при загрузке страницы
  useEffect(() => {
    if (!document.cookie.includes('cookieAccepted=true')) {
      setShowBanner(true); // Показываем баннер, если согласие ещё не было дано
    }
  }, []);

  const handleAcceptCookies = () => {
      const CookieDate = new Date();
      CookieDate.setFullYear(CookieDate.getFullYear() + 1);
      const cookieString = 'cookieAccepted=true; path=/;';
      document.cookie = cookieString + ' Expires=' + CookieDate.toUTCString() + ';';

    setShowBanner(false); // Скрываем баннер после принятия
  };

  return (
    !showBanner ? <></>: (
      <div className="cookie-form__cookie-block">
        <p>
            <span>ООО БК «Ингосстрах-Инвестиции» на сайте осуществляет сохранение файлов «cookie» и обработку обезличенных пользовательских технических и аналитических данных с применением сервиса «Яндекс.Метрика» в соответствии с </span>
            <a href="https://www.ingobroker.ru/api/uploads/Politika_obrabotki_P_Dn_BK_on_Notification_66ad9bacab.pdf" target="_blank"><span className="ingos-btn__content">Политикой обработки персональных данных</span></a>
            <span> для проведения маркетингового анализа, персонализации сервиса и обеспечения работы пользователей с сайтом. Продолжая работу с сайтом, вы соглашаетесь с действиями ООО БК «Ингосстрах-Инвестиции». Вы также можете запретить сохранение файлов «cookie» в настройках своего браузера.</span>
        </p>
        <Button 
          onClick={handleAcceptCookies} 
          title="Понятно"
          size="s"
          />
      </div>
    )
  );
};

export default CookieBanner;